import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const inputVariants = cva(
	// Base styles
	"flex w-full rounded-md font-roboto transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
	{
		variants: {
			variant: {
				default: "border border-input bg-card focus:border-brand-500 focus:ring-2 focus:ring-brand-500/30",
				filled: "border border-border bg-muted focus:bg-card focus:border-brand-500 focus:ring-2 focus:ring-brand-500/30",
				ghost: "border-0 bg-transparent focus:bg-muted"
			},
			size: {
				sm: "h-7 px-2.5 text-sm",
				md: "h-9 px-3 text-base",
				lg: "h-10 px-3.5 text-lg"
			},
			state: {
				default: "",
				error: "border-red-500 focus:border-red-500 focus:ring-red-500",
				success: "border-green-500 focus:border-green-500 focus:ring-green-500"
			}
		},
		defaultVariants: {
			variant: "default",
			size: "md",
			state: "default"
		}
	}
);

const Input = forwardRef(({
	className,
	variant,
	size,
	state,
	type = "text",
	...props
}, ref) => {
	return (
		<input
			type={type}
			className={cn(inputVariants({ variant, size, state, className }))}
			ref={ref}
			{...props}
		/>
	);
});

Input.displayName = "Input";

export { Input, inputVariants }; 